let future;
let data;

export function init(paymentData, deposit, payFullAmount) {
    data = paymentData;
    data.totalDeposit = deposit;

    future = [];
    angular.forEach(paymentData.products, function(prod) {
        angular.forEach(prod.schedule, function(s) {
            future.push({
                schedule: s,
                prod
            });
        });
    });

    future.sort(function(p1, p2) {
        return p1.schedule.due - p2.schedule.due;
    });

    return change(payFullAmount);
}

export function change(payingFullAmount) {
    angular.forEach(future, function(f) {
        if (payingFullAmount) {
            f.schedule.balance = 0;
            f.prod.currentDeposit = f.prod.cost;
        } else {
            f.schedule.balance = f.schedule.amount;
            f.prod.currentDeposit = f.prod.initialDeposit;
        }
    });

    data.totalBalances = 0;
    data.balanceSchedules = [];

    const balancesByDate = {};

    angular.forEach(data.products, function(prod) {
        prod.balance = 0;
        angular.forEach(prod.schedule, function(s) {
            prod.balance += s.balance;
            data.totalBalances += s.balance;
            if (s.balance) {
                if (balancesByDate[s.due] == null) {
                    balancesByDate[s.due] = {
                        balance: 0,
                        due: s.due
                    };
                }
                balancesByDate[s.due].balance += s.balance;
            }
        });
    });

    data.balanceSchedules = Object.keys(balancesByDate).map(k => balancesByDate[k]);

    return data;
}
